import { render, staticRenderFns } from "./Tabe.vue?vue&type=template&id=fa2daf82&scoped=true"
import script from "./Tabe.vue?vue&type=script&lang=js"
export * from "./Tabe.vue?vue&type=script&lang=js"
import style0 from "./Tabe.vue?vue&type=style&index=0&id=fa2daf82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2daf82",
  null
  
)

export default component.exports